import { Link } from 'react-router-dom';

import { assets, campaign } from './campaign';

const dates = [
  {
    label: campaign.electionDayName,
    value: campaign.electionDay,
    detail: campaign.electionDayHours,
  },
  {
    label: 'Early Voting',
    value: 'June 1-5 and June 8-9',
    detail: 'Two voting windows before runoff day',
  },
  { label: 'Runoff Race', value: 'Vote Beau Rawlins', detail: campaign.office },
];

function ElectionInformationPage() {
  return (
    <main className="bg-white px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto max-w-3xl text-center">
          <p className="font-black uppercase tracking-[0.2em] text-[#8f6400]">
            Election information
          </p>
          <h1
            className="mt-3 text-5xl font-black text-[#6f2182]"
            style={{ fontFamily: 'Source Serif 4, serif' }}
          >
            Vote Beau Rawlins in the District 5 runoff.
          </h1>
          <p className="mt-5 text-lg leading-8 text-[#66546f]">
            Runoff Election Day is Saturday, June 13, 2026. Polls are open 7:00 AM - 7:00 PM, with
            early voting available June 1-5 and June 8-9.
          </p>
        </div>

        <section className="mt-12 grid gap-6 md:grid-cols-3">
          {dates.map((item) => (
            <div
              key={item.label}
              className="rounded-[2rem] border-t-8 border-[#f5c400] bg-[#f8f1fb] p-8 shadow-xl"
            >
              <p className="text-sm font-black uppercase tracking-[0.2em] text-[#6f2182]">
                {item.label}
              </p>
              <p className="mt-3 text-2xl font-black text-[#281331]">{item.value}</p>
              <p className="mt-2 text-sm font-bold text-[#66546f]">{item.detail}</p>
            </div>
          ))}
        </section>

        <section className="mt-10 grid gap-6 lg:grid-cols-2">
          <div className="rounded-[2rem] border-4 border-[#f5c400] bg-white p-8 shadow-xl">
            <p className="text-sm font-black uppercase tracking-[0.2em] text-[#6f2182]">
              Early voting times
            </p>
            <ul className="mt-5 space-y-3 text-lg font-bold text-[#281331]">
              {campaign.earlyVoting.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p className="mt-7 text-sm font-black uppercase tracking-[0.2em] text-[#6f2182]">
              Early voting locations
            </p>
            <ul className="mt-5 space-y-3 leading-7 text-[#66546f]">
              {campaign.earlyVotingLocations.map((location) => (
                <li key={location}>{location}</li>
              ))}
            </ul>
          </div>

          <div className="rounded-[2rem] bg-[#6f2182] p-8 text-white shadow-xl">
            <p className="text-sm font-black uppercase tracking-[0.2em] text-[#f5c400]">
              Election Day voting
            </p>
            <p className="mt-4 text-3xl font-black" style={{ fontFamily: 'Source Serif 4, serif' }}>
              Saturday, June 13, 2026
            </p>
            <p className="mt-2 text-xl font-bold text-white/85">{campaign.electionDayHours}</p>
            <ul className="text-white/82 mt-7 space-y-3 leading-7">
              {campaign.electionDayLocations.map((location) => (
                <li key={location}>{location}</li>
              ))}
            </ul>
          </div>
        </section>

        <section className="mt-12 grid gap-8 rounded-[2rem] bg-[#6f2182] p-8 text-white shadow-xl lg:grid-cols-[1fr_0.95fr] lg:items-center">
          <div>
            <p className="font-black uppercase tracking-[0.2em] text-[#f5c400]">Make a plan</p>
            <h2
              className="mt-3 text-4xl font-black"
              style={{ fontFamily: 'Source Serif 4, serif' }}
            >
              District 5 elections can be close. Every runoff vote matters.
            </h2>
            <p className="text-white/78 mt-5 text-lg leading-8">
              Check your registration early, confirm your polling place, and remind neighbors that
              the runoff is separate from the May 2 general election.
            </p>
            <div className="mt-8 flex flex-col gap-4 sm:flex-row">
              <a
                href={campaign.officialElectionUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full bg-[#f5c400] px-7 py-3 text-center text-sm font-black uppercase tracking-[0.16em] text-[#431052] transition hover:bg-white"
              >
                Official election page
              </a>
              <a
                href={campaign.galvestonVotesUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full border-2 border-white px-7 py-3 text-center text-sm font-black uppercase tracking-[0.16em] text-white transition hover:bg-white hover:text-[#6f2182]"
              >
                Galveston Votes
              </a>
            </div>
          </div>
          <Link
            to="/contact"
            className="block rounded-3xl bg-white p-5 text-center shadow-xl transition hover:-translate-y-1"
          >
            <img
              src={assets.logo}
              alt="Re-elect Beau Rawlins logo"
              className="mx-auto max-h-[28rem] rounded-2xl object-contain"
            />
            <span className="mt-5 inline-block rounded-full bg-[#f5c400] px-7 py-3 text-sm font-black uppercase tracking-[0.16em] text-[#431052]">
              Volunteer for the runoff
            </span>
          </Link>
        </section>
      </div>
    </main>
  );
}

export default ElectionInformationPage;
